export default function ProgressBar({ current, total, label }) {
  const pct = Math.max(0, Math.min(100, ((current + 1) / total) * 100));
  return (
    <div data-testid="builder-progress" className="w-full">
      <div className="flex items-center justify-between text-[11px] tracking-[0.22em] uppercase text-[#A1A1AA]">
        <span>
          Step {current + 1} / {total}
        </span>
        <span className="text-[#D4AF37] truncate max-w-[60%] text-right">{label}</span>
      </div>
      <div className="mt-2 h-1 w-full rounded-full bg-[#1a1a1a] overflow-hidden">
        <div
          className="h-full bg-gradient-to-r from-[#B8902C] via-[#D4AF37] to-[#F3E5AB] transition-all duration-500"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
